// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoPlayer_wrapper__s0KXB","preview":"VideoPlayer_preview__TRJWU","icon":"VideoPlayer_icon__DXcb8","poster":"VideoPlayer_poster__AjQO7","video":"VideoPlayer_video__Y9L3m"};